<template>
    <Modal @modal:dismiss="$emit('dismiss')">
        <h3 slot="header">{{ value.id ? 'Modifier' : 'Créer' }} un attribut</h3>

        <div slot="body">
            <div class="form-control">
                <label>
                    Nom de l'attribut <b>(obligatoire)</b>
                    <CustomInputUniqChecker
                        :disabled="!!value.id"
                        required
                        class="stretch"
                        v-model="value.name"
                        :err-msg="`Un attribut nommé ${value.name} existe déjà`"
                        url="/api/check/tag/name"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Traduction française de l'attribut
                    <CustomInput
                        class="stretch"
                        placeholder="Entrez la traduction de l'attribut"
                        v-model="value.name_fr"
                    />
                </label>
            </div>
        </div>

        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch" @click="$emit('dismiss')">Annuler</CustomButton>
                <CustomButton class="stretch default" @click="$emit('close')">
                    Enregistrer
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import CustomInput from './../Input';
import CustomButton from './../Button';
import CustomInputUniqChecker from './../InputUniqChecker';

export default {
    props: ['value'],
    data() {
        return {};
    },
    components: {
        Modal,
        CustomInput,
        CustomButton,
        CustomInputUniqChecker,
    },
};
</script>

<style lang="scss"></style>
